import { Box, Typography } from '@mui/material';

interface PaymentSubHeaderProps {
  headerText: string;
}

const PaymentSubHeader = ({ headerText }: PaymentSubHeaderProps) => {
  return (
    <Box
      data-testid="paymentSubHeader"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        pt: { mobile: 3, tablet: 2, desktop: 9 },
        width: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { mobile: 'column', tablet: 'row' },
          justifyContent: {
            mobile: 'none',
            tablet: 'space-between',
          },
          alignItems: { mobile: 'none', tablet: 'flex-end', desktop: 'none' },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 500,
            fontSize: { mobile: 33, tablet: 44 },
            pb: { mobile: 0.5, tablet: 1 },
            lineHeight: { mobile: '48px', tablet: '56px' },
          }}
        >
          {headerText}
        </Typography>
      </Box>
    </Box>
  );
};

export default PaymentSubHeader;
